/* __next_internal_client_entry_do_not_use__ ProductTileClickImpressionProvider auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { ProductTileClickImpressionContext } from "@faire/retailer-visitor-shared/hooks/ProductTileImpression/__internal__/ProductTileClickImpressionContext";
import React, { useMemo, useRef } from "react";
export var ProductTileClickImpressionProvider = function(param) {
    var children = param.children, containerName = param.containerName, context = param.context, productTileContainer = param.productTileContainer, requestId = param.requestId, isNewProductsCategory = param.isNewProductsCategory, screenContext = param.screenContext, containerContext = param.containerContext, contextToken = param.contextToken;
    var badgeEventTokens = useRef(new Set());
    var value = useMemo(function() {
        return {
            requestId: requestId,
            containerName: containerName === null || containerName === void 0 ? void 0 : containerName.replace("_old", ""),
            context: context,
            productTileContainer: productTileContainer,
            badgeEventTokens: badgeEventTokens.current,
            screenContext: screenContext,
            containerContext: containerContext,
            contextToken: contextToken,
            isNewProductsCategory: isNewProductsCategory
        };
    }, [
        containerName,
        productTileContainer,
        context,
        requestId,
        isNewProductsCategory,
        screenContext,
        containerContext,
        contextToken
    ]);
    return /*#__PURE__*/ _jsx(ProductTileClickImpressionContext.Provider, {
        value: value,
        children: children
    });
};
